import type { Components } from '@mui/material/styles';
import { type Theme } from '@mui/material/styles';

export const typographyTheme: Pick<Components<Theme>, 'MuiTypography'> = {
  MuiTypography: {
    defaultProps: {
      variantMapping: {
        h1: 'h1',
        h2: 'h2',
        h3: 'h3',
        h4: 'h4',
        h5: 'h5',
        h6: 'h6',
        subtitle1: 'p',
        subtitle2: 'p',
        body1: 'p',
        body2: 'p',
        code: 'code',
        codeBlock: 'code',
        metaLabel: 'p',
        inherit: 'p',
      },
    },
    styleOverrides: {
      root: ({ theme }) => ({
        variants: [
          {
            props: { variant: 'metaLabel' },
            style: {
              color: theme.palette.text.secondary,
            },
          },
        ],
      }),
    },
  },
};
